import { Box } from '@mui/material';
import React from 'react';

import { ChevronRedCircle } from '@common/components/ChevronRedCircle';
import { PaginationArrowProps } from '@common/types/campaign';
import {
  ARROW_SCALE,
  CONTROL_SIZE,
} from '@common/utils/campaignPaginationItems';

/**
 * PaginationArrow
 *
 * Renders the pagination arrow
 * @param direction - the direction of the arrow
 * @param disabled - whether the arrow is disabled
 * @param onClick - the function to call when the arrow is clicked
 */
export function PaginationArrow({
  direction,
  disabled = false,
  onClick,
}: PaginationArrowProps) {
  return (
    <Box
      component="button"
      type="button"
      aria-label={
        direction === 'left' ? 'Go to previous page' : 'Go to next page'
      }
      disabled={disabled}
      onClick={onClick}
      sx={{
        '&:hover': {
          background: 'none',
        },
        alignItems: 'center',
        background: 'none',
        border: 'none',
        cursor: disabled ? 'default' : 'pointer',
        display: 'inline-flex',
        flexShrink: 0,
        height: CONTROL_SIZE,
        justifyContent: 'center',
        opacity: disabled ? 0.5 : 1,
        padding: 0,
        width: CONTROL_SIZE,
      }}
    >
      <ChevronRedCircle
        centered
        direction={direction === 'left' ? 'left' : 'right'}
        disabled={disabled}
        scale={ARROW_SCALE}
      />
    </Box>
  );
}
